import * as XLSX from "xlsx";
import http from "Utils/api2";
import { formattedDateServer } from "Utils/dateFunc";

// Fetch data from a specific page
const fetchData = async (url, page = 1) => {
  try {
    // Safely append page param — use & if URL already has ?, else use ?
    const separator = url.includes("?") ? "&" : "?";
    const res = await http.get(`${url}${separator}page=${page}`);
    return res.data?.data || [];
  } catch (error) {
    
    return [];
  }
};

export const generateExcelWithAllOrderData = async ({ url, totalPages, loading, ecom }) => {
  loading(true);

  try {
    // Fallback if totalPages is undefined
    const pagesToFetch = totalPages || 1;

    const pagePromises = [];
    for (let page = 1; page <= pagesToFetch; page++) {
      pagePromises.push(fetchData(url, page));
    }

    const allPagesData = await Promise.all(pagePromises);
    const combinedData = allPagesData.flat();

    if (!combinedData.length) {
      
      return;
    }

    exportToExcel(combinedData, ecom);
  } catch (error) {
    
  } finally {
    loading(false);
  }
};


// Export to Excel function
const exportToExcel = (allListData, ecom) => {
  if (!allListData || !allListData.length) return;

  const data = allListData.map((ele, i) => {
    const rawPrice = ele?.finalPayableAmount ?? ele?.orderTotal ?? null;
    const num = rawPrice !== null ? parseFloat(rawPrice) : 0;
    // Format as string so Excel left-aligns it (numbers are right-aligned by default in Excel)
    const totalPrice = isNaN(num)
      ? "Rs. 0.00"
      : "Rs. " + num.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const dateValue = ecom
      ? ele?.createdAt || ele?.serviceDateTime
      : ele?.serviceDateTime || ele?.createdAt;

    return {
      "S.No": String(i + 1),   // string → left-aligned in Excel
      "User Name":
        ele?.customerId?.fullName ||
        ele?.userId?.fullName ||
        (ele?.address?.firstName ? `${ele?.address?.firstName} ${ele?.address?.lastName}` : "-"),
      "Order Id": ele?._id || "-",
      "Order Status": ele?.bookingStatus || ele?.status || "-",
      "Payment Method": ele?.paymentMethod || "-",
      "Order Total Price (INR)": totalPrice,  // formatted string → left-aligned in Excel
      "Place Order": dateValue ? formattedDateServer(new Date(dateValue)) : "-",
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, ecom ? "E-Commerce Orders" : "Service Orders");

  // ── Per-column widths ─────────────────────────────────────────────
  // Columns: S.No | User Name | Order Id | Order Status | Payment Method | Total Price | Place Order
  worksheet["!cols"] = [
    { wpx: 45  },  // S.No       — narrow
    { wpx: 160 },  // User Name  — wide
    { wpx: 200 },  // Order Id   — widest (MongoDB _id is long)
    { wpx: 130 },  // Status
    { wpx: 120 },  // Payment Method
    { wpx: 130 },  // Total Price
    { wpx: 110 },  // Place Order
  ];

  // ── Apply cell-level number format for Total Price column (col index 5) ──
  // NOTE: Price is now a formatted string, so no number format needed.
  // Removed to prevent type mismatch.

  // Save Excel file
  XLSX.writeFile(workbook, ecom ? "E-Commerce Orders.xlsx" : "Service Orders.xlsx");
};
